document.addEventListener('DOMContentLoaded', function () {
  const button = document.querySelector('.mobile-menu-button');
  const nav = document.querySelector('#MainNav');

  if (button && nav) {
    button.addEventListener('click', function () {
      const open = nav.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
});